import * as Actions from "../action/claim";

const initialState = {
    agencyData: [], 
    loading :true
};
 
const agencyReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_AGENCY: {
      return {
        ...state,
        agencyData: action.payload, 
        loading :false,
      };
    }
    case Actions.GET_AGENCY_ERROR:
      return {
        ...state,
        agencyData: [],
        loading: false,
      };

    default:
      return state;
  }
};
export default agencyReducer;